module.exports = __webpack_public_path__ + "static/media/1711343033964.0460a247.jpg";